import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";

const TableWrapperStyle = styled(Table)(
    ({ theme }) => `
    .table {
        .table-row {
            &:hover {
                background-color: ${theme.palette.action.hover};
                transition: background-color 0.2s ease;
            }
        }

        .table-cell {
            border-bottom: 1px solid ${theme.palette.divider};
            padding: ${theme.spacing(1.5)};
            
            .table-value {
                font-size: 0.875rem;
                font-weight: 500;
                
                &.fit {
                    white-space: nowrap;
                }
            }
        }
    }
`
);

export default TableWrapperStyle;
